import { repository } from "repositories";
import { GetTopicCategoryListRes, SWRResponse } from "shared/types";
import useSWR from "swr";

export const useTopicCategoryList = (
  mediaType: "press" | "miracle"
): SWRResponse<GetTopicCategoryListRes> => {
  const repo = repository.topicCategory.getList(mediaType);
  const { data, error, mutate } = useSWR([repo.path, mediaType], repo.data);

  return {
    categories: data?.categories,
    isLoading: !data && !error,
    isError: !!error,
    mutate,
  };
};
